import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

import { useParams } from "react-router-dom";
import { endPoints } from "../../config/end-points";
import useHttp from "../../hooks/use-http";
import { authActions } from "../../store/auth";
import { campaignAction } from "../../store/campaign-store";
import { landingPageAction } from "../../store/landingpage-store";
import "./landing.css";

const ListLandingPage = () => {
  const dispatch = useDispatch();
  const { camp_id } = useParams();
  const { sendRequest } = useHttp();
  const history = useHistory();
  const landingpages = [
    {
      id: 1,
      thumbnail:
        "https://d37q3r06begyqi.cloudfront.net/VidAmaze/landingpages/landing_1.png",
    },
    {
      id: 2,
      thumbnail:
        "https://d37q3r06begyqi.cloudfront.net/VidAmaze/landingpages/landing_2.png",
    },
    {
      id: 3,
      thumbnail:
        "https://d37q3r06begyqi.cloudfront.net/VidAmaze/landingpages/landing_3.png",
    },
    {
      id: 4,
      thumbnail:
        "https://d37q3r06begyqi.cloudfront.net/VidAmaze/landingpages/landing_4.png",
    },
    {
      id: 5,
      thumbnail:
        "https://d37q3r06begyqi.cloudfront.net/VidAmaze/landingpages/landing_5.png",
    },
    {
      id: 6,
      thumbnail:
        "https://d37q3r06begyqi.cloudfront.net/VidAmaze/landingpages/landing_6.png",
    },
    {
      id: 7,
      thumbnail:
        "https://d37q3r06begyqi.cloudfront.net/VidAmaze/landingpages/landing_7.png",
    },
  ];

  //   const is_page_load = useSelector((state) => state.landingpage.is_page_load);

  useEffect(() => {
    document.title = `${endPoints.title} | Select Landing Page`;
    dispatch(authActions.setLoaderStatus({ status: true }));
    dispatch(campaignAction.preState({ camp_id }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [camp_id]);

  useEffect(() => {
    // console.log(is_page_load);

    sendRequest(
      {
        url: endPoints.fetchLandingPage + "/" + camp_id,
        body: "",
        method: "GET",
      },
      (response) => {
        if (response.status === 200) {
          if (response.body) {
            // redirect to edit landing page
            // console.log(response);
            dispatch(
              landingPageAction.setPagecontent({
                status: response.body.status,
                content: response.body.content,
              })
            );
            history.push("/" + camp_id + "/edit-landing");
          }
        }

        // dispatch(landingPageAction.setPageLoad({ is_page_load: true }));
        dispatch(authActions.setLoaderStatus({ status: false }));
      }
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //   console.log(landingpages);

  const handlelandingPage = (page_id) => {
    // console.log(page_id);
    dispatch(authActions.setLoaderStatus({ status: true }));
    sendRequest(
      {
        url: endPoints.insertLandingpage,
        body: { camp_id, page_id },
        method: "POST",
      },
      (response) => {
        // console.log(response);
        if (response.status === 200) {
          history.push("/" + camp_id + "/edit-landing");
        }
      }
    );
  };

  return (
    <>
      <section className="mid_wrap">
        <div className="container">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb mb-4 pb-2">
              <li className="breadcrumb-item">
                <a href="#0">Dashboard</a>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Landing Page Selection
              </li>
            </ol>
          </nav>

          <h3 className="mb-4">Select Template</h3>
          <div className="row">
            {landingpages.length > 0 &&
              landingpages.map((page) => {
                return (
                  <div className="col-xl-4 col-lg-4 col-md-4" key={page.id}>
                    <div className={`vd_cl `}>
                      <div className="series_vd position-relative">
                        <img
                          src={page.thumbnail}
                          alt="img"
                          className="landing-img"
                        />
                      </div>
                      <div className="bdy_vd position-relative">
                        <button
                          className="btn btn2 w-100"
                          onClick={(e) => {
                            handlelandingPage(page.id);
                          }}
                        >
                          Select and Continue
                        </button>
                      </div>
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
      </section>
    </>
  );
};

export default ListLandingPage;
